import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { WEB_COMPONENT_MOBILE_SECURITY_CUSTOMER_VIEW } from '../../../webcomponents.constants';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <header class="page__header">
      <gz-title id='page-title' fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
    </header>
    <div class='grid-wrapper'>
      <gz-grid-view class='grid-view'>
      </gz-grid-view>
    </div>

    <div class='customer-wrapper'>
      <${WEB_COMPONENT_MOBILE_SECURITY_CUSTOMER_VIEW} />
    </div>
  </div>
`;
